import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const ProductAdditionalDefaultProps = {
  ...BaseDefaultProps,
  agrementFgaz: null,
  bundleParents: [],
  discountClass: null,
  discountClasses: [],
  discountLabel: null,
  getDiscountLabel: () => null,
  id: null,
  isNotSalable: false,
  isSubstitute: false,
  quoteNumber: null,
  substitute: null,
};

export const ProductAdditionalPropTypes = {
  ...BasePropTypes,
  agrementFgaz: PropTypes.string,
  bundleParents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      slug: PropTypes.string,
    }),
  ),
  discountClass: PropTypes.string,
  discountClasses: PropTypes.arrayOf(PropTypes.shape({})),
  discountLabel: PropTypes.string,
  getDiscountLabel: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isNotSalable: PropTypes.bool,
  isSubstitute: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  quoteNumber: PropTypes.number,
  substitute: PropTypes.string,
};
